
import {throwError as observableThrowError, Observable} from 'rxjs';

import {catchError, tap} from 'rxjs/operators';
import {Injectable, Injector} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const auth = this.injector.get(AuthenticationService);
    if (request.url.indexOf('oauth/token') == -1) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${auth.getToken()}`
        }
      });
    }
    return next.handle(request).pipe(
      tap((ev: HttpEvent<any>) => {
        //  something?
      }),
      catchError(response => {
        if (response instanceof HttpErrorResponse) {
          if (response.status === 401) {
            auth.logout();
          }
        }
        return observableThrowError(response);
      }),);
  }
}
